var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutralLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 12,
    viewBox: "0 0 67 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.9998L11.1016 5.5605C12.9488 4.56586 15.1282 4.39037 17.1107 5.07664L23.2908 7.21589C25.6141 8.02012 28.1841 7.63457 30.1692 6.184L35.0201 2.63918C37.9137 0.524744 41.8988 0.75283 44.5322 3.18359L48.715 7.04455C51.2355 9.37115 55.0133 9.69122 57.8894 7.82183L62.2429 4.99209C62.7458 4.66521 63.2861 4.39984 63.8522 4.20166L65.5 3.62485",
    stroke: "url(#paint0_linear_52641_12422)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52641_12422",
    x1: 72.5294,
    y1: -8.25079,
    x2: -5.09125,
    y2: -1.55089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251389,
    stopColor: "#F3BF71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralLine);
export default __webpack_public_path__ + "static/media/neutral-line.01201e5cb1e1aaec7d027257b8c86652.svg";
export { ForwardRef as ReactComponent };